// extracted by mini-css-extract-plugin
module.exports = {"details":"OrderIndicatorDetails_details__1zyTj"};